import { McAction } from '../IMcAction';
import initialState, { ILabState } from '../modules/lab/ILabState';
import {
    SET_CURRENT_LAB, CLEAR_CURRENT_LAB, GET_LABS_SUCCESS,
    GET_LAB_INSTRUMENTS_SUCCESS,
    GET_STUDY_TEST_TEA_CONFIGS
} from '../modules/lab/lab.action.const';

import {
    selectCurrentLab, clearCurrentLab, getLabSuccess,
    getLabInstruments,
    getStudyTestTeaConfigs
} from '../modules/lab/lab.reducer.logic';

export function labReducer(state: ILabState = initialState, action: McAction) {
    switch (action.type) {
        case SET_CURRENT_LAB:
            return selectCurrentLab(state, action);

        case CLEAR_CURRENT_LAB:
            return clearCurrentLab(state, action);

        case GET_LABS_SUCCESS:
            return getLabSuccess(state, action);

        case GET_LAB_INSTRUMENTS_SUCCESS:
            return getLabInstruments(state, action);

        case GET_STUDY_TEST_TEA_CONFIGS:
            return getStudyTestTeaConfigs(state, action);

        default:
            return state;
    }
}





// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/lab.reducer.ts